import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-detailed-generic-user',
    templateUrl: './detailed-generic-user.component.html',
    styleUrls: ['./detailed-generic-user.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DetailedGenericUserComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
